import { useEffect, useState } from 'react';
import { difference } from 'lodash';
import usePrevious from '../../effects/usePrevious';

const useFieldsController = (values, directions, setValue, extraFields) => {
  /**
   * set initial direction only once
   */
  const [isLock, setLockStatus] = useState(false);

  const prevDirections = usePrevious(directions);
  const prevExtraFields = usePrevious(extraFields);

  useEffect(() => {
    if (prevExtraFields) {
      const deletedDir = difference(prevExtraFields, extraFields);

      if (deletedDir) {
        deletedDir.forEach(field => setValue(field));
      }
    }
  }, [extraFields]);

  useEffect(() => {
    if (isLock) {
      return;
    }
    if (!prevDirections?.length && directions?.length) {
      setLockStatus(true);
      if (directions.length === 1) {
        const direction = [directions[0].value];
        setValue('direction', direction);
      }
    }
  }, [directions]);
};

export default useFieldsController;
